var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinusinactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus-circle",
    "data-name": "Icon awesome-minus-circle",
    d: "M40.563.563a40,40,0,1,0,40,40A39.993,39.993,0,0,0,40.563.563ZM19.272,47.014a1.941,1.941,0,0,1-1.935-1.935V36.046a1.941,1.941,0,0,1,1.935-1.935H61.853a1.941,1.941,0,0,1,1.935,1.935v9.032a1.941,1.941,0,0,1-1.935,1.935Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#9d9d9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusinactive);
export default __webpack_public_path__ + "static/media/minusinactive.9127ebda7a0c5ccfd119ca573397ea7d.svg";
export { ForwardRef as ReactComponent };